import React, { useState } from 'react';
import axios from 'axios';
import ReactMarkdown from 'react-markdown';
import SideNavbar from './helpers/SideNavbar';
import SideNav from './helpers/SideNavbar';


const AIComponent = () => {
  const [question, setQuestion] = useState('');
  const [answer, setAnswer] = useState('');
  const [generatingAnswer, setGeneratingAnswer] = useState(false);

  async function generateAnswer(e) {
    e.preventDefault();
    setGeneratingAnswer(true);
    setAnswer('Loading your answer... \n It might take up to 10 seconds');

    try {
      const apiKey = process.env.REACT_APP_API_GENERATIVE_LANGUAGE_CLIENT; // Access the API key
      const response = await axios({
        url:`https://generativelanguage.googleapis.com/v1beta/models/gemini-2.0-flash:generateContent?key=${apiKey}`,
        
        method: 'post',
        data: {
          contents: [{ parts: [{ text: question }] }],
        },
      });

      setAnswer(response.data.candidates[0].content.parts[0].text);
    } catch (error) {
      console.error(error);
      setAnswer('Sorry, Something went wrong. Please try again!');
    } finally {
      setGeneratingAnswer(false);
    }
  }

  return (
    <div className="">
    <SideNav>
      <div class="card shadow-sm p-3" style={{border:'none', backgroundColor:'#fff'}}>
        <div class="card-header" style={{border:'none', backgroundColor:'#fff'}}>
        <h5 className="welcome-text" style={{fontSize:'20px',color:'#2e3192',textAlign:'left'}}>KnackVibes AI</h5>

        </div>
        <hr/>
      <form
        onSubmit={generateAnswer}
        className=""
      >
        <a href="https://github.com/codeaashu/Helpmate-AI" target="_blank" rel="noopener noreferrer">
        </a>
        <textarea 
          required
          style={{fontSize:'15px',
            borderRadius:'8px',
            border:'1px solid #cfeafb',
            background:'#FFFFFF',
           height:'150px !important',
          width:'100%',
          padding:'0px 20px',
          fontSize:'16px',
          lineHeight:'60px'
          }}
          className="border border-gray-300 rounded w-full focus:shadow-lg mt-5" 
          value={question}
          onChange={(e) => setQuestion(e.target.value)}
          placeholder="Take help with your AI mate!"
        ></textarea><br/>
        <button
        style={{backgroundColor:'#2e3192',borderRadius:8}}
          type="submit"
          className={`bg-blue-500 text-white p-3 mt-3 rounded-md hover:bg-blue-600 transition-all duration-300 ${
            generatingAnswer ? 'opacity-50 cursor-not-allowed' : ''
          }`}
          disabled={generatingAnswer}
        >
          Generate answer
        </button>
      </form>
      <div className="w-full md:w-2/3 lg:w-1/2 xl:w-1/3 text-center rounded-lg bg-white my-4 shadow-lg transition-all duration-500 transform hover:scale-105">
        <ReactMarkdown className="p-4">{answer}</ReactMarkdown>
      </div>
      </div>
      </SideNav>
      </div>
     
   
  );
};

export default AIComponent;


// import React, { useState,useEffect } from 'react';
// import axios from 'axios';
// import SideNav from './helpers/SideNavbar';

// // const NEWS_API_KEY = "35cb6fbec68f4d49aef91260d349e562"; // Replace with your actual API key
// const NEWS_API_KEY ="KGVwDY9TjrzvTSF7qHy3TaU2kxlOR5awtmfMxZiz"
// const GEMINI_API_KEY = "AIzaSyCQTFhomyBU-eLnOt9HsnBq3Ro0Wy9xQCY"; // Replace with your actual API key

// const AIComponent = () => {
//   const [topic, setTopic] = useState("");
//   const [news, setNews] = useState([]);
//   const [linkedinPost, setLinkedinPost] = useState("");
//   const [loading, setLoading] = useState(false);
// const [accessToken, setAccessToken] = useState('');
//   const [accountype, setAccountType] = useState('');
//   const [userId, setUserId] = useState('');

//   useEffect(() => {
//       const storedAccessToken = localStorage.getItem('AccessToken');
//       const storedUserId = localStorage.getItem('Tokenid');
//       const storedAccountType = localStorage.getItem('AccountType');
//       if (storedAccessToken && storedUserId && storedAccountType) {
//         setAccessToken(storedAccessToken);
//         setUserId(storedUserId);
//         setAccountType(storedAccountType)
//       } else {
//         console.error('No accessToken or userId found in localStorage');
//       }
//     }, []);

//   // Function to fetch trending news dynamically based on user input
// //   const fetchTrendingTopics = async () => {
// //       if (!topic.trim()) {
// //           alert("Please enter a topic.");
// //           return;
// //       }

// //       setLoading(true);
// //       try {
// //           const response = await axios.get(`https://newsapi.org/v2/everything`, {
// //               headers: { Authorization: `Bearer ${NEWS_API_KEY}` },
// //               params: { q: topic, language: "en", pageSize: 5, sortBy: "relevancy" }
// //           });
// //           if (response.data.articles) {
// //             // Sorting articles by `publishedAt` in descending order (latest first)
// //             const sortedArticles = response.data.articles.sort((a, b) => 
// //                 new Date(b.publishedAt) - new Date(a.publishedAt)
// //             );
// // console.log("sorted",sortedArticles)
// //             setNews(sortedArticles.map((article) => article.title));
          
// //           } else {
// //               setNews([]);
// //           }
// //       } catch (error) {
// //           console.error("Error fetching news:", error);
// //       }
// //       setLoading(false);
// //   };

// const fetchTrendingTopics = async () => {
//   if (!topic.trim()) {
//       alert("Please enter a topic.");
//       return;
//   }

//   setLoading(true);
//   try {
//       const response = await axios.get("https://api.thenewsapi.com/v1/news/all", {
//           params: {
//               api_token: NEWS_API_KEY, // API key as a param
//               search: topic, // The topic to search for
//               language: "en", // English language
//               limit: 5, // Number of articles to fetch
//               locale: "us" // Fetch US news
//           }
//       });

//       if (response.data.data && response.data.data.length > 0) {
//           const sortedArticles = response.data.data.sort((a, b) => 
//               new Date(b.published_at) - new Date(a.published_at)
//           );
//           console.log("Sorted News:", sortedArticles);
//           setNews(sortedArticles.map((article) => article.title));
//       } else {
//           setNews([]);
//       }
//   } catch (error) {
//       console.error("Error fetching news:", error);
//   }
//   setLoading(false);
// };

//   // Function to generate LinkedIn post using Gemini AI
//   const generateLinkedInPost = async () => {
//       if (news.length === 0) return;

//       setLoading(true);
//       const model = "gemini-2.0-flash";
//       const prompt = `
//       Create a concise and engaging LinkedIn post highlighting the latest trends about "${topic}" and suggest a unique perspective:
//       ${news.join(", ")}.

//       Format this post professionally for a tech-focused LinkedIn audience.
//       `;

//       try {
//           const response = await axios.post(
//               `https://generativelanguage.googleapis.com/v1beta/models/${model}:generateContent?key=${GEMINI_API_KEY}`,
//               { contents: [{ parts: [{ text: prompt }] }] },
//               { headers: { "Content-Type": "application/json" } }
//           );

//           if (response.data.candidates) {
//               setLinkedinPost(response.data.candidates[0].content.parts[0].text.trim());
//           } else {
//               console.error("No response from Gemini API");
//           }
//       } catch (error) {
//           console.error("Error generating LinkedIn post:", error);
//       }
//       setLoading(false);
//   };

//   const handlePostToLinkedIn = async () => {
//     try {
//       if (!accessToken || !userId) {
//         throw new Error("Access Token or User ID is missing");
//       }
      
//       if (!linkedinPost) {
//         alert("No content available to post!");
//         return;
//       }
  
//       // Format text properly before posting (remove any unwanted HTML)
//       const plainTextContent = linkedinPost
//         .replace(/<\/?br\s*\/?>/g, "\n") // Convert <br> tags to new lines
//         .replace(/<\/?p>/g, "\n") // Convert <p> tags to new lines
//         .replace(/<\/?[^>]+(>|$)/g, ""); // Remove any remaining HTML tags
  
//       // API request to post text to LinkedIn
//       const resp = await axios.post(
//         `${process.env.REACT_APP_API_BASE_URL}/api/linkedin/post-content`,
//         {
//           accessToken,
//           userId,
//           text: plainTextContent, // Send the cleaned text
//           accountype,
//         },
//         {
//           headers: {
//             Authorization: `Bearer ${accessToken}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );
  
//       if (resp.status === 200) {
//         Swal.fire({
//           position: "center",
//           icon: "success",
//           title: "Posted successfully",
//           showConfirmButton: false,
//           timer: 3000,
//         });
//       } else {
//         Swal.fire({
//           position: "center",
//           icon: "error",
//           title: "Error posting to LinkedIn!",
//           showConfirmButton: false,
//           timer: 3000,
//         });
//       }
//     } catch (error) {
//       console.error(
//         "Error posting to LinkedIn:",
//         error.response ? error.response.data : error.message
//       );
      
//     }
//   };
  
//   return (
//     <div>
//     <SideNav>
//       <div style={{ padding: "20px", maxWidth: "600px", margin: "auto", textAlign: "center" }}>
//           <h2>AI-Powered LinkedIn Post Generator</h2>

//           {/* Textarea for user to input their topic */}
//           <textarea
//               rows="3"
//               style={{ width: "100%", padding: "10px", marginBottom: "10px" }}
//               placeholder="Enter a topic (e.g., AI trends, cloud computing, cybersecurity)..."
//               value={topic}
//               onChange={(e) => setTopic(e.target.value)}
//           />

//           <button style={{ backgroundColor: '#2e3192',borderRadius:8 }}
//               className="bg-blue-500 text-white p-3 rounded-md hover:bg-blue-600 transition-all duration-300 mt-5" onClick={fetchTrendingTopics} disabled={loading}>
//               {loading ? "Fetching News..." : "Get News"}
//           </button>

//           {/* Display fetched news articles */}
//           {news.length > 0 && (
//               <>
//                   <h3>Trending News:</h3>
//                   <ul style={{ textAlign: "left" }}>
//                       {news.map((item, index) => (
//                           <li key={index}>{item}</li>
//                       ))}
//                   </ul>
//                   <button style={{ backgroundColor: '#2e3192',borderRadius:8 }}
//               className="bg-blue-500 text-white p-3 rounded-md hover:bg-blue-600 transition-all duration-300 mt-5" onClick={generateLinkedInPost} disabled={loading}>
//                       {loading ? "Generating Post..." : "Generate LinkedIn Post"}
//                   </button>
//               </>
//           )}

//           {/* Display AI-generated LinkedIn post */}
//           {linkedinPost && (
//               <div>
//                   <h3>Generated LinkedIn Post:</h3>
//                   <p style={{ background: "#f4f4f4", padding: "10px", borderRadius: "5px" }}>{linkedinPost}</p>
//               </div>
//           )}
//            <div>
//             <button
//               style={{ backgroundColor: '#2e3192',borderRadius:8 }}
//               className="bg-blue-500 text-white p-3 rounded-md hover:bg-blue-600 transition-all duration-300 mt-5"
//               onClick={()=>handlePostToLinkedIn()}
//               // disabled={!accessToken || !userId || (!aiContent && !postContent)}
//             >
//               Post to LinkedIn
//             </button>
//           </div>
//       </div>
//       </SideNav>
//       </div>
//   );
// };

// export default AIComponent;

